import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useDemographicsData } from "~/hooks/useDemographicsData";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import { LoadingSpinner, Text } from "@local-logic/core/ui";
import * as DemographicsTabs from "./DemographicsTabs";
import * as ChartLayout from "./ChartLayout";
import * as styles from "./styles";

export const Content = () => {
  const { t } = useTranslation("localDemographics");
  const { demographicsState, activeCategory, setDemographicsState } =
    useDemographics();
  const { data: demographicsData, isFetching: isDemographicsFetching } =
    useDemographicsData({
      lat: demographicsState.location.lat,
      lng: demographicsState.location.lng,
    });

  useEffect(() => {
    if (!isDemographicsFetching && demographicsData) {
      setDemographicsState({
        ...demographicsData,
      });
    }
  }, [isDemographicsFetching]);

  const GetActiveTabContent = () => {
    if (isDemographicsFetching) {
      return (
        <div className={styles.spinner}>
          <LoadingSpinner />
        </div>
      );
    }

    if (demographicsData === undefined) {
      return (
        <div className={styles.noDataElement}>
          <Text variant="h6" weight="--ll-font-weight-bold">
            {t("noData")}
          </Text>
        </div>
      );
    }

    switch (activeCategory) {
      case "income":
        return <ChartLayout.Income />;
      case "population":
        return <ChartLayout.Population />;
      case "housing":
        return <ChartLayout.Housing />;
      case "household":
        return <ChartLayout.Household />;
      case "commute":
        return <ChartLayout.Commute />;
      case "education":
        return <ChartLayout.Education />;
      case "languages":
        return <ChartLayout.Languages />;
      default:
        return <div>{activeCategory} tab</div>;
    }
  };

  return (
    <DemographicsTabs.Content options={{ value: activeCategory }}>
      <ChartLayout.Root>{GetActiveTabContent()}</ChartLayout.Root>
    </DemographicsTabs.Content>
  );
};
